import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { Storage } from "@ionic/storage";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
// import { ShopperBuySocialPayScanPage } from "../shopper-buy-social-pay-scan/shopper-buy-social-pay-scan";
import { ShopperBuySocialPayInputPage } from "../shopper-buy-social-pay-input/shopper-buy-social-pay-input";

@IonicPage()
@Component({
  selector: "page-shopper-buy-social",
  templateUrl: "shopper-buy-social.html",
})
export class ShopperBuySocialPage {
  plazas: any;
  plaza_id: any;
  plaza = "";
  shops: any;
  shopSelect: any = [];
  social_mission = "";
  social_group = "";
  url: any;
  budget: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.plaza_id = this.navParams.data.plaza_id;
    this.social_mission = this.navParams.data.social_mission;
    this.social_group = this.navParams.data.social_group;

    if (this.plaza_id == 1) {
      this.plaza = "A";
    } else if (this.plaza_id == 2) {
      this.plaza = "B";
    } else if (this.plaza_id == 3) {
      this.plaza = "C";
    } else if (this.plaza_id == 4) {
      this.plaza = "D";
    } else if (this.plaza_id == 5) {
      this.plaza = "E";
    } else if (this.plaza_id == 6) {
      this.plaza = "F";
    } else {
      this.plaza = this.plaza_id;
    }
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperShop + this.plaza_id + "/socials";

      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.shops = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      this.storage.get("info").then((info) => {
        if (info.role == 1) {
          this.url = this.services.URLPlazaStatBudgets;
        } else if (info.role == 2) {
          this.url = this.services.URLMerchantStatBudgets;
        } else if (info.role == 3) {
          this.url = this.services.URLShopperStatBudgets;
        }
        var link = this.url;

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.budget = this.services.currencyFormat(data.available);
            },
            (error) => {
              // console.log(error);
              this.services.presentToastInternet();
            }
          );
      });
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperShop + this.plaza_id + "/socials";

      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.shops = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      this.storage.get("info").then((info) => {
        if (info.role == 1) {
          this.url = this.services.URLPlazaStatBudgets;
        } else if (info.role == 2) {
          this.url = this.services.URLMerchantStatBudgets;
        } else if (info.role == 3) {
          this.url = this.services.URLShopperStatBudgets;
        }
        var link = this.url;

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.budget = this.services.currencyFormat(data.available);
            },
            (error) => {
              // console.log(error);
              this.services.presentToastInternet();
            }
          );
      });
    });
    refresher.complete();
  }

  selectShop(shop_id) {
    var findArr = this.findData(shop_id);
    // console.log("findArr=", findArr);

    if (findArr) {
      this.removeArr(shop_id);
    } else {
      this.shopSelect = [shop_id];
    }
  }

  findData(id) {
    var found = this.shopSelect.find(function (element) {
      return element == id;
    });
    // console.log("found=", found);
    if (found == id) {
      return true;
    } else {
      return false;
    }
  }

  removeArr(id) {
    var indexID = this.shopSelect.indexOf(id);
    this.shopSelect.splice(indexID, 1);
    // console.log("data=", data);
    // console.log("shopSelect remove=", this.shopSelect);
    return true;
  }

  buy() {
    if (this.shopSelect.length > 0) {
      this.navCtrl.push(ShopperBuySocialPayInputPage, {
        plaza_id: this.plaza_id,
        social_mission: this.social_mission,
        social_group: this.social_group,
        items: [
          {
            social_shop_id: this.shopSelect[0],
            qty: 1,
          },
        ],
      });
    } else {
      this.translateService
        .get("Please select the social shop you want to buy.")
        .subscribe((value) => {
          this.services.presentToast(value);
        });
    }
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social/shopper-buy-social.ts